"use client"
import { ReactNode, useContext, useMemo } from "react"
import { ScrollContext } from "./context"

/* eslint-disable react-hooks/exhaustive-deps */
// todo change back still not working
type Props = {
  id: string
  title: string
  children: ReactNode
} & React.HTMLProps<HTMLButtonElement>

const Section = ({ id, title, children, ...rest }: Props) => {
  const { registerRef } = useContext(ScrollContext)
  const ref = useMemo(() => registerRef(id), [id])

  return (
    <section
      {...rest}
      ref={ref as React.RefObject<HTMLElement>}
      data-title={title}
      id={id}
    >
      {children}
    </section>
  )
}

export default Section
